export default __webpack_public_path__ + "static/media/stablecoin.02d840b1.svg";